import { render, staticRenderFns } from "./amountDetail.vue?vue&type=template&id=7d831cbb&scoped=true"
import script from "./amountDetail.vue?vue&type=script&lang=js"
export * from "./amountDetail.vue?vue&type=script&lang=js"
import style0 from "./amountDetail.vue?vue&type=style&index=0&id=7d831cbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d831cbb",
  null
  
)

export default component.exports